import React from "react";
import { Cart } from "../../store/cart/types";
import { Box, Text } from "@chakra-ui/layout";
import AppButton from "../global/forms/AppButton";
import { formatCurrency } from "../global/data/formatCurrencyHelper";

interface CartSummaryProps {
  cart: Cart;
  goForward: () => void;
}

const CartSummary: React.FC<CartSummaryProps> = ({ cart, goForward }) => {
  const countCartQuantity = (cart: Cart | null): number => {
    if (!cart) {
      return 0
    }
    let totalQuantity = 0;
  
    if (cart.items && cart.items.length > 0) {
      for (const item of cart.items) {
        if (item.selected) totalQuantity += item.quantity;
      }
    }
    return totalQuantity;
  };

  const getCartTotal = (cart: Cart | null): number => {
    if (!cart) {
      return 0
    }
    let total = 0;
  
    if (cart.items && cart.items.length > 0) {
      for (const item of cart.items) {
        if (item.selected) total += item.quantity * item.price;
      }
    }
    return total;
  };

  const count = countCartQuantity(cart);
  const total = getCartTotal(cart);
  let currency =  'JMD'; 
  if (cart.items && cart.items.length > 0) currency = cart.items[0].currency; // must change when dealing with multicurrency

  return (
    <Box
    role={'group'}
    p={6}
    w={'full'}
    bg={'white'}
    boxShadow={'md'}
    rounded={'lg'}
    pos={'relative'}
    mb={3}
    zIndex={0}
  >
    <Box maxW={'xl'}>
      <Text fontSize={'lg'} fontWeight={'bold'}>{`Sub-Total (${count} selected item${count === 1 ? '' : 's'}): ${formatCurrency(currency, total)}`}</Text>
      <AppButton text={'Checkout'} onClick={() => goForward()} isDisabled={count===0}/>
    </Box>
  </Box>    
  );
}

export default CartSummary;